import { render, staticRenderFns } from "./TakipAltTipForm.vue?vue&type=template&id=ea3d5796"
import script from "./TakipAltTipForm.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports